import { useState, useEffect } from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../assets/images/sample2.jpg";
import { documents, infinityIcon, globeIcon, chatIcon, awardIcon, playIcon, usersIcon, clockIcon, layersStackIcon, bookIcon, cubeIcon, scorm } from "../../constants/icons";
import { Route, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { setCart } from "../../reducers/cartSlice";
import { validity } from "./common/commonfn";
import { set } from "date-fns";
import BuyNowButton from "./BuyNowButton";
import AddToCartButton from "./AddToCartButton";
import EnrollNowButton from "./EnrollNowButton";
import RedirectURLObject from "../RedirectURLObject";
import IamInterestedButton from "./IamInterestedButton";
import{ pluralize } from "../../helpers/string_helper";

function AddToCartVerticalBlock({ className, totalLecturesCount, totalCoursesCount, coursedetails, itemType = 'course', currentDateTime ='', eventSessions }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const paths = useSelector((state) => state.user.paths);
  const fields = useSelector((state) => state);
  const miscellaneous = useSelector((state) => state.user.miscellaneous);
  const loggedInUser = useSelector((state) => state.user.user);
  let current_url = window.location.origin;
  // const selectedTimeZone =  miscellaneous.configured_time_zone;
  const shopping_cart = miscellaneous.shopping_cart;
  // const selectedUTCOffset = selectedTimeZone.utc_offset_seconds * 1000; // converting minutes to milli seconds
  const [eventStatusBtn, setEventStatusBtn]   = useState('');
  const [isEnquiryNeeded, setIsEnquiryNeeded] = useState('0');
  const [isFree, setIsFree] = useState('0');
  const [cardImage, setCardImage] = useState('');
  const [carttext, setCartText] = useState(null);
  const [newbutton, setNewbutton] = useState("");
  const [disabledcart, setDisabledCart] = useState("");
  const [itemPrice, setItemPrice] = useState(0);
  const [itemPriceLabel, setItemPriceLabel] = useState('0');
  const [memberPriceStatus, setMemberPriceStatus] = useState('0');
  const [memberPrice, setMemberPrice] = useState('0');
  const [languages, setLanguages] = useState('');
  const [itemTypeText, setItemTypeText] = useState('course');
  // const subscription_status = coursedetails?.course.cb_imported === undefined ? true : coursedetails?.course.cb_imported == "0" || (coursedetails?.course.cb_imported == "1" && coursedetails?.course.cb_no_of_subscriptions > coursedetails?.course.item_enrolled_learners_count);
  const [comingSoon, setComingSoon]               = useState(0);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);
  const [taxMethod, setTaxMethod]                   = useState('0');
  const [eventActivities, setEventActivities] = useState([]);
  let eventStatusButton                             = '';
  let self_enroll_temp;
  if (itemType == 'booking_event') {
    self_enroll_temp = coursedetails?.course.bce_registration_status === '0' ? false : true;
  } else {
    self_enroll_temp = coursedetails?.course.cb_has_self_enroll === undefined ? true : (coursedetails?.course.cb_has_self_enroll == "0" ? false : (coursedetails?.course.cb_self_enroll_date === null ? true : (new Date(coursedetails?.course.cb_self_enroll_date).getTime() >= new Date(miscellaneous.current_date).getTime())));
  }
  const self_enroll = self_enroll_temp;

  let isCertificate;
  if (itemType == 'booking_event') {
    isCertificate = coursedetails?.course.bce_certificate_available;
  } else {
    isCertificate = Array.isArray(coursedetails?.certificate_lecture);
  }
  const waitingListURL = RedirectURLObject({ type: 'enroll_now', redirectTo: `/cart_react?item=${itemType}_${coursedetails?.course.id}` })
  const certificate = isCertificate;
  let defaultImage = paths.default_course;

  useEffect(() => {
    if (coursedetails && coursedetails.course && typeof coursedetails.course !== 'undefined') {
      if (itemType == 'booking_event') {
        if (coursedetails.course.bce_thumbnail == '') {
          setCardImage(paths.default_event + coursedetails.course.bce_thumbnail);
        } else {
          setCardImage(paths.event_path + coursedetails.course.bce_thumbnail);
        }
        let isFreeTemp = coursedetails.course.bce_pricetype == 'paid' ? '0' : '1';
        setIsFree(isFreeTemp);
        setIsEnquiryNeeded(coursedetails.course.bce_enquiry_needed);
        setItemPrice(coursedetails.course.bce_price);
        setItemPriceLabel(coursedetails.course.bce_price_label);
        setMemberPriceStatus(coursedetails.course.bce_member_status);
        setMemberPrice(coursedetails.course.bce_member_price);
        setItemTypeText('event');
        setComingSoon(coursedetails.course.coming_soon);
        setTaxMethod(coursedetails.course.bce_tax_method);
        let subStatus = (coursedetails.course.registration_closed == 1 || coursedetails.course.registration_disabled == 1) ? false : true;

        let event_total_registrations         = coursedetails.course.bce_total_registrations;
        let event_maximum_registration_limit  = coursedetails.course.bce_maximum_registration_limit;
        let event_attendee_waiting_enabled    = coursedetails.course.bce_attendee_waiting;
        let allow_register                    = coursedetails.course.allow_register;
        let eventDateTime                     = coursedetails.course.bce_start_date+' '+coursedetails.course.bce_start_time;
        let _currentDateTime                  = currentDateTime;

        let seat_waiting = false;
        let seat_available =false;
        let seat_sold = false;
        let coming_soon = coursedetails.course.coming_soon;

        if(event_total_registrations == null || event_total_registrations == 'null'){
          event_total_registrations  = 0;
        } 
        if (coursedetails.course.registration_disabled == 0) {       
          if (parseInt(event_total_registrations) >= parseInt(event_maximum_registration_limit)) {
             seat_sold = true;
             allow_register = false;
             if (event_attendee_waiting_enabled == 1) {
                allow_register = true;
                seat_waiting = true;
             }
          } else {
             seat_available = true;
          }                  
       }

       if(seat_waiting === true || allow_register === false){
        subStatus = false;
       }

       setSubscriptionStatus(subStatus);

      //  console.log('seat_sold', seat_sold);
      //  console.log('allow_register', allow_register);
      //  console.log('seat_waiting', seat_waiting);

       //

       if(eventDateTime >= _currentDateTime) 
       {
         if (coursedetails.course.registration_disabled == 0) {
           if (coursedetails.course.registration_closed == true) {
            eventStatusButton = <Button variant="outline" className="w-100 mb-3" size="md">Registration closed</Button>;
           } else if (allow_register == 1) {
             if (seat_waiting == true) {
              eventStatusButton = <Button variant="outline" className="w-100 mb-3" size="md" onClick={() => {localStorage.setItem('onlyWaitingList', true);waitingListURL.isReact ? navigate(waitingListURL.url) : window.location.href = waitingListURL.url}}>Add to waiting list</Button>;
             } else if (seat_available == true) {
              //  if(isFree == '1'){
                // eventStatusButton = <Button variant="outline" className="w-100 mb-3" size="md">{miscellaneous.event_free_button}</Button>;
                 // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_enroll_button_display" onclick="enrollItem(${event_id},'booking_event', '${bce_slug}')">${_free_event_btn}</button>`;
              //  } else if(isCartEnabled){
                 
                //  if(inCart(event_id,'booking_event')){
                   
                //    addToCartButton = <AddToCartButton itemId={coursedetails.course.id} itemType={itemType}/>; //<Button variant="outline" className="w-100 mb-3" size="md">Go to Cart</Button>;
                //    buyNowButton    = <BuyNowButton itemId={coursedetails.course.id} itemType={itemType}/>;//<Button variant="secondary"  className="w-100 mb-3"  size="md">Buy now</Button>;
                //      eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="goToCart()">Go to Cart</button>`;  
                //      // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${event_id},'booking_event')">${_event_buy_now_label} </button>`;  
                //  }
                //  else{
 
                  //  addToCartButton = <AddToCartButton itemId={coursedetails.course.id} itemType={itemType}/>; //<Button variant="outline" className="w-100 mb-3" size="md">Add to Cart</Button>;
                  //  buyNowButton    = <BuyNowButton itemId={coursedetails.course.id} itemType={itemType}/>;//<Button variant="secondary"  className="w-100 mb-3"  size="md">Buy now</Button>;
                    //  eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn w-100" onclick="addToCart(this, ${event_id},'booking_event')" style="margin-right: 10px;">Add to Cart</button>`;  
                     // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${event_id},'booking_event')">${_event_buy_now_label}</button>`;  
                  //  }
              //  }else
              //  {
                //  buyNowButton    = <BuyNowButton itemId={coursedetails.course.id} itemType={itemType}/>;//<Button variant="secondary"  className="w-100 mb-3"  size="md">Buy now</Button>;
                 // eventsHtml += `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${event_id},'booking_event')">${_event_buy_now_label}</button>`;  
              //  }
             }       
           } else { 
             if (seat_sold == true) {
              eventStatusButton    = <Button variant="outline" className="w-100 mb-3" size="md">Sold Out</Button>;
                //  eventsHtml        += '<p class="reg-closed">Sold Out</p>';
             } else if (coming_soon == true) {
              eventStatusButton    = <Button variant="outline"  className="w-100 mb-3"  size="md">Coming Soon</Button>;
                //  eventsHtml        += '<p class="reg-closed">Coming Soon</p>';
             }
             }
         } else {
          // eventStatusButton    = <Button variant="outline" className="w-100 mb-3" size="md" onClick={viewMoreClickHandler}>  View More</Button>;
        //  eventsHtml        += bce_enquiry_needed != '1' ? '<p class="reg-closed reg-unavailable">Temporarily Unavailable</p>' : '';
         }
       }

       setEventStatusBtn(eventStatusButton);
       //

       /* EVENT SESSION ACTIVITIES */
        if (coursedetails?.event_all_activity) {
          const sessionActivities = coursedetails?.event_all_activity.reduce((acc, curr) => {
            if (curr.ea_activity_type !== "session") {
              acc[curr.ea_activity_type] = (acc[curr.ea_activity_type] || 0) + 1;
            }
            return acc;
          }, {});
          setEventActivities(sessionActivities);
        }

      } else {
        setCardImage(coursedetails?.course_image);
        setIsFree(coursedetails.course.cb_is_free);
        setIsEnquiryNeeded(coursedetails.course.cb_enquiry_needed);
        let current_price = coursedetails?.course.cb_discount > 0 ? coursedetails?.course.cb_discount : coursedetails?.course.cb_price;
        setItemPrice(current_price);
        setItemPriceLabel(coursedetails.course.cb_price_label);
        setMemberPriceStatus(coursedetails.course.cb_member_status);
        setMemberPrice(coursedetails.course.cb_member_price);
        setLanguages(coursedetails.course.cb_language);
        setTaxMethod(coursedetails.course.cb_tax_method);
        setSubscriptionStatus(coursedetails?.course.item_b2b_imported === undefined ? true : coursedetails?.course.item_b2b_imported == "0" || (coursedetails?.course.item_b2b_imported == "1" && coursedetails?.course.item_no_of_subscriptions > coursedetails?.course.item_enrolled_learners_count));
      }
    }

  }, [coursedetails])

  // function convertUTCDateToLocalDate(date) {
  //   var newDate = new Date(date.getTime() - date.getTimezoneOffset()*60*1000);
  //   console.log(newDate,"newDate")
  //   return newDate;   
  // }

  // const validity = (args) => {
  //   console.log(Number(coursedetails?.course.cb_validity), "args")
  //   let course_validity
  //   // args = "1";
  //   switch (args) {
  //     case "0":
  //       course_validity = 'Unlimted Validity';
  //       break;
  //     case "1":
  //       course_validity = coursedetails?.course.cb_validity > 1 ? coursedetails?.course.cb_validity + ' Days' : coursedetails?.course.cb_validity + ' Day';
  //       course_validity = "Validity:" + course_validity
  //       // echo daysToMonth($course['cb_validity']);
  //       break;
  //     case "2":
  //       // console.log(selectedUTCOffset,"selectedUTCOffset")
  //       //convertUTCDateToLocalDate(coursedetails?.course.cb_validity_date)
  //       // course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' : current_date_format(1, convert_to_user_time($course['cb_validity_date']), 2);
  //       // course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' : coursedetails?.course.cb_validity_date
  //       //  course_validity =  coursedetails?.course.cb_validity_expired ? 'Expired' :  
  //       //  new Date(new Date(coursedetails?.course.cb_validity_date).getTime() + selectedUTCOffset);
  //       course_validity = coursedetails?.course.cb_validity_date;
  //       // return coursedetails?.course.cb_validity_date;
  //       course_validity = "Expiring on:" + course_validity
  //       break;
  //     default:
  //       // course_validity = 'Lifetime';
  //       break;
  //   }
  //   return course_validity
  // }
  // let course_validity
  // switch (coursedetails?.course.cb_access_validity)
  // {
  //     case 0:
  //         course_validity = 'Lifetime';
  //         break;
  //     case 1:
  //         course_validity =  $course['cb_validity'] > 1 ? $course['cb_validity'] . ' Days' : $course['cb_validity'] . ' Day';
  //         // echo daysToMonth($course['cb_validity']);
  //         break;
  //     case 2:
  //         course_validity =  $course['cb_validity_expired'] ? 'Expired' : current_date_format(1, convert_to_user_time($course['cb_validity_date']), 2);
  //         break;
  //     default:
  //         break;
  // } 

  useEffect(() => {
    let id = coursedetails?.course.id;
    let cart = localStorage.getItem("mycart");
    cart = JSON.parse(cart)
    if (!cart) {
      cart = {}
    }
    if (id) {
      id = itemType + "_" + id
      if (typeof cart[id] != "undefined") {
        setCartText(true)
      }
      else {
        setCartText(false)
      }
    }

  }, [coursedetails]);

  useEffect(() => {
    // console.log(shopping_cart, "shopping_cart")
    if (self_enroll == false && isFree === '1' && shopping_cart == false && isEnquiryNeeded === '0' && miscellaneous.enquiry_button_enabled == false) {
      setDisabledCart(<Button
        variant="secondary"
        className="w-100 mb-3"
        size="md"
        disabled
        onClick={() => BuyNowfn(false, coursedetails?.course.id, itemType)}
      >
        {itemType == 'booking_event' ? miscellaneous.event_buy_now_button : miscellaneous.buy_now_button}
      </Button>
      )
    }

  }, [self_enroll]);





  const current_price_fn = () => {
    let current_price = coursedetails?.course.cb_discount > 0 ? coursedetails?.course.cb_discount : coursedetails?.course.cb_price;
    if (itemType == 'booking_event') {
      return coursedetails?.current_currency.symbol + itemPrice;
    } else {
      return coursedetails?.current_currency.symbol + current_price;
    }
  }

  const discount_price_fn = () => {
    let orginal_price = 0
    if (isFree !== '1' && coursedetails?.course.cb_discount > 1) {
      orginal_price = 1
      return coursedetails?.current_currency.symbol + coursedetails?.course.cb_price
    }
  }

  const member_price_fn = () => {
    if (memberPriceStatus == 1) {
      return coursedetails?.current_currency.symbol + memberPrice;
    }
    // if (coursedetails?.course.cb_member_status == 1) {
    //   return coursedetails?.current_currency.symbol + coursedetails?.course.cb_member_price
    // }
  }

  const postFormDataAsJson = (apiCall, formData) => {
    // console.log("ff")
    // console.groupCollapsed('postFormDataAsJson');
    //  console.log(formData);
    // console.groupEnd();

    const formDataJsonString = JSON.stringify(formData);
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: formDataJsonString,
    };

    const response = fetch(apiCall, fetchOptions)
      .then((response) => response.json())
    console.log(response, "response")
    //setCartText(true)
    // if (!response.ok) {
    // 	const errorMessage =  response.text();
    // 	throw new Error(errorMessage);
    // }

    // return response.json();
  }


  const addToCartFn = (item = false, id, item_type, learners = {}, other = {}) => {
    if (localStorage.getItem("mycart") == "[]") localStorage.setItem("mycart", "{}");
    var cart = localStorage.getItem("mycart") != null ? JSON.parse(localStorage.getItem("mycart")) : {};
    var oncart = true;
    var index = (item_type + '_' + id);

    if (!cart[index]) {

      cart[index] = {
        "id": id,
        "type": item_type,
        "learners": learners,
        "metadata": {},
        "other": other,
      };
      var cart_temp = cart[index];
      var cart_count = Object.keys(cart).length;
      cart = JSON.stringify(cart);
      localStorage.setItem("mycart", cart);
      localStorage.setItem("mycart_count", cart_count);
      var data = {};
      data[index] = cart_temp;
      let current_url = window.location.origin
      // postFormDataAsJson(current_url+'/cart_react/add_to_cart', data);
      // var isloggedin = localStorage.getItem('cart_user_session');
      // setCartText(true)
      // postFormDataAsJson(current_url + '/api/cart_react/add_to_cart', data);
      if (loggedInUser.is_logged_in) {
        var data = {};
        data[index] = cart_temp;
        postFormDataAsJson(current_url + '/api/cart_react/add_to_cart', data);
      }
      dispatch(setCart({ cartCount: cart_count }));
      // setCartText(true)
      window.location.href = "/cart_react";

    }
  }

  const BuyNowfn = (item = false, id, item_type, learners = [], other = {}) => {
    let ppsEnabled = 0;
    let bookingStatus = '1';
    let slug = '';
    var index = (item_type + '_' + id);
    let current_url = window.location.origin
    let isGuestEnabled = "";
    if ((typeof (loggedInUser.logged_in_user.id) != 'undefined' && loggedInUser.logged_in_user.id != '') || isGuestEnabled == '1') {
      window.location = current_url + '/cart_react?item=' + index;
    }
    else {
      window.location = current_url + 'login';
    }

    // if((typeof(loggedUserid) != 'undefined' && loggedUserid != '') || isGuestEnabled == '1'){
    // 	window.location = site_url+'cart_react?item='+index;
    // } else {
    //     afterLoginCallBack = {
    //         callback : 'buyNow',
    //         id : id,
    //         type : item_type,
    //         slug : slug,
    //         ppsEnabled : ppsEnabled,
    //         bookingStatus : bookingStatus
    //     };
    //     let url = site_url+'cart_react?item='+index;
    //     window.location = __site_url + 'login'+'?redirect_url='+encodeURIComponent(url);
    //     // $('#sign-in').modal('show');

    //     set_cookies(__memcacheKey+'redirect_url', url, (300));
    // }
  }

  const languagefn = (language) => {
    let listLanguage = [];
    if (language && language.length == 1) {
      listLanguage = language[0]['cl_lang_name'];
    }
    else {
      listLanguage = language && language.map(lang => (
        lang.cl_lang_name
      ))
    }
    let listLanguagestring = listLanguage && listLanguage.toString();
    listLanguagestring = listLanguagestring.replace(",", ", ");
    return listLanguagestring
  }

  const enquirefn = (coursedetails, itemType) => {
    const course_name = itemType == "booking_event" ? coursedetails?.course?.bce_name : coursedetails?.course?.cb_title;
    navigate(`/enquiry?name=${encodeURIComponent(course_name)}&type=${itemType == "booking_event" ? "event" : encodeURIComponent(itemType)}&id=${encodeURIComponent(coursedetails?.course?.id)}`)
  }


  let link = ""
  if (loggedInUser.is_logged_in) {
    link = coursedetails?.preview_link
  }
  else {
    link = `${current_url}/login/sso?redirect_url=${coursedetails?.preview_link}`
  }

  const linkfn = () => {

  }

  // $total_hours         = explode('-', $course['cb_total_video_hours']);
  // if (!empty($total_hours[0]))
  // {
  //     $total_time       = $total_hours[0];
  //     $total_time_type  = isset($total_hours[1]) ? ucfirst($total_hours[1]) : 'Hours';
  // }
  const TotalHoursFn = (hour) => {
    if (hour) {
      let totalhours = hour.split("-");
      let total_time
      let total_time_type
      if (totalhours.length > 0) {
        total_time = totalhours[0];
        if (typeof totalhours[1] !== 'undefined') {
          total_time_type = totalhours[1]
          if (total_time_type == "hours") {
            total_time_type = "Hours"
          }
          else {
            total_time_type = "Minutes"
          }
        }
      }
      return total_time + " " + total_time_type;
    }

  }

  return (
    <div className="addtocart-block-wrapper">
      <div className={`${className || ""} carousel-block p-0`}>
        <div className="img-carousel">
          {/* <img src={coursedetails?.course_image} className="img-fluid" alt="course-image"/> */}
          {/* <img src={cardImage} className="img-fluid" alt="course-image" /> */}
          <img
            src={cardImage}
            className="img-fluid"
            alt="course-image"
          // onError={({ currentTarget }) => {
          //   currentTarget.onerror = null; // prevents looping
          //   currentTarget.src = defaultImage;
          // }}
          />
          {coursedetails?.course.cb_preview == 1 &&
            <>
              <a href={link}><div onClick={linkfn} className="btn-play">
                {playIcon}
              </div></a>
              <a href={link} className="title-preview">Preview this course</a>
            </>
          }
        </div>

        <div className="desc-carousel">
          {itemPriceLabel == 1 &&
            <div className="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
              {isFree !== "1" ?
                <div className="pricing-slot pricing-left">
                  <span>{miscellaneous.current_pricing_label}</span>
                  <div className="price">{coursedetails && current_price_fn()}<span>{coursedetails && discount_price_fn()}</span></div>
                  {/* <div className="price">Free</div> */}
                </div>
               :
               <div className="pricing-slot pricing-left">
               {/* <span>{miscellaneous.miscellaneous.free_label}</span> */}
               <div className="price">{itemType == 'booking_event' ? miscellaneous.event_free_label : miscellaneous.free_label}</div>
               {/* <div className="price">Free</div> */}
             </div> }
              <span className="separtor-price-set"></span>
              {isFree != "1" && memberPriceStatus == "1" &&
                <div className="pricing-slot pricing-right">
                  <span>{miscellaneous.member_pricing_label}</span>
                  <div className="price"> {coursedetails && member_price_fn()}
                    {/* <span>₹229</span> */}
                  </div>
                </div>
              }
            </div>
          }

          {itemPriceLabel == 1 && isFree != "1" ? taxMethod == 0 ?
            <p className="exclusive-info">Inclusive of all taxes*</p> : <p className="exclusive-info">Exclusive of all taxes*</p> : ""}
          <div className="rating-cart-wrapper pt-0 border-0">
            {eventStatusBtn}
            { coursedetails?.course?.bce_is_approval_required == "1" && <IamInterestedButton item={{item_name: coursedetails?.course?.bce_name,item_id:coursedetails?.course?.id}} variant="outline"  itemId={coursedetails?.course?.id} />}
            
            {shopping_cart == true && isFree != 1 && self_enroll == true && comingSoon != '1' && subscriptionStatus == true && coursedetails?.course?.bce_is_approval_required != "1" &&
              <AddToCartButton itemId={coursedetails?.course.id} itemType={itemType}/>
            }
            { coursedetails?.course?.bce_is_approval_required != "1" && subscriptionStatus == true && self_enroll == true ? isFree == 1 ?
            (
              comingSoon != '1' && coursedetails?.course?.bce_is_approval_required != "1" && <EnrollNowButton variant="outline" itemType={itemType} itemId={coursedetails?.course.id} className="w-100 mb-3"/>
            ) : ( 
              comingSoon != '1' ?
              <BuyNowButton itemId={coursedetails?.course.id} itemType={itemType}/>
              : ('')
              )
            : ""}
            { miscellaneous.enquiry_button_enabled == true ? 
            isEnquiryNeeded == 1 && 
              <Button
                variant="outline"
                className="w-100 border-0 mb-0"
                size="md"
                onClick={() => enquirefn(coursedetails, itemType)}
              >
                {chatIcon} {miscellaneous.enquiry_button}
              </Button> : ""
            }


          </div>
          <div className="course-inclusion pt-3 mt-3">
            <h1>This {itemTypeText} includes:</h1>
            <ul>
              {
                itemType != 'booking_event' &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {documents}
                  {/* <span>{coursedetails?.course.lecture_count} Lectures</span> */}
                  <span>{totalLecturesCount} {totalLecturesCount == 1 ? "Lecture" : "Lectures"} </span>
                </li>
              }
              {
                itemType == 'booking_event' && eventActivities &&
                Object.entries(eventActivities).map(([key, value]) => (
                <li className="d-flex align-items-center gap-1 mb-2">
                  {key === "Course" ? documents : key === "Bundle" ? documents : key === "Lab" ? cubeIcon : key === 'Practical' ? bookIcon : scorm}
                  <span>{value} {pluralize(value, key)}</span>
                </li>
                ))
              }
              {
                itemType != 'booking_event' &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {infinityIcon}
                  <span>{validity(coursedetails?.course.cb_access_validity, coursedetails)}</span>
                </li>
              }

              {(!certificate && itemType == 'course') &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {awardIcon}
                  <span>Certificate of completion</span>
                </li>
              }
              {
                (certificate === '1' && itemType == 'booking_event') &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {awardIcon}
                  <span>Certificate of completion</span>
                </li>
              }
              {/* {console.log(coursedetails?.course.cb_language, "lang")} */}
              {languages.length > 0 &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {globeIcon}
                  <span>{languagefn(languages)}</span>
                </li>
              }
              {
                itemType != 'booking_event' &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {clockIcon}
                  <span>{TotalHoursFn(coursedetails?.course.cb_total_video_hours)}</span>
                </li>
              }

              {coursedetails?.course.cb_has_show_total_enrolled == 1 &&
                <li className="d-flex align-items-center gap-1 mb-2">
                  {usersIcon}
                  <span>{coursedetails?.course.enrolled_students} Enrolled</span>
                </li>
              }
            </ul>
          </div>
        </div>
      </div>
      {/* <div className="addtocart-bottom-info">
        <h1>Get Subscription</h1>
        <p>Expert-led courses across a variety of online class topics for every step of your career. Instructors with real-world experience.</p>
        <Button
          variant="primary"
          className="w-100 mb-0"
          size="md"
        >
          Start my 1-month free trial
        </Button>
      </div> */}
    </div>
  );
}

export default AddToCartVerticalBlock;
